var lazyLoad;

window.onload = (event) => {
	console.log('Loaded');
	setupCommon();
};

function setupCommon() {
	setupImages();
	fadeInElement('.fadeInElement');
}

function setupImages() {
	lazyLoad = new LazyLoad({
		elements_selector: '.lazy',
		threshold: 500,
		load_delay: 0,
	});
}

function fadeInElement(element) {
	$(element).each(function (i) {
		$(this)
			.delay((i + 1) * 150)
			.fadeTo(300, 1);
	});
}
